import {
  selAreaToTime,
  selBaseInfoSubsidiary,
  selRecordRemindSchemeByPage,
  selHarvestYield,
  selBaseInfoAreaAndYield,
  selCategoryNum,
  selCountPdmgCategoryTrendMJ,
  selectAllManageManufacturerListByGroup,
  selManageManufacturerListByPage,
  selectStatIndustryInfoIntegrationListByGroup,
  selStatIndustryInfoIntegrationListPage,
} from '@/api/manage';

export default {
  namespaced: true,
  actions: {
    // 查询土地面积
    async selAreaToTime(context, params) {
      const { data } = await selAreaToTime(params);
      return data;
    },
    // 查询土地附属信息
    async selBaseInfoSubsidiary(context, params) {
      const { data } = await selBaseInfoSubsidiary(params);
      return data;
    },
    // 查询方案和种植面积
    async selRecordRemindSchemeByPage(context, params) {
      const { data } = await selRecordRemindSchemeByPage(params);
      return data;
    },
    // 查询累计收获产量
    async selHarvestYield(context, params) {
      const { data } = await selHarvestYield(params);
      return data;
    },
    // 查询种植面积和产量
    async selBaseInfoAreaAndYield(context, params) {
      const { data } = await selBaseInfoAreaAndYield(params);
      return data;
    },
    async selCategoryNum(context, params) {
      const { data } = await selCategoryNum(params);
      return data;
    },
    async selCountPdmgCategoryTrendMJ(context, params) {
      const { data } = await selCountPdmgCategoryTrendMJ(params);
      return data;
    },
    async selCountPdmgCategoryTrendCL(context, params) {
      const { data } = await selCountPdmgCategoryTrendCL(params);
      return data;
    },
    async selectAllManageManufacturerListByGroup(context, params) {
      const { data } = await selectAllManageManufacturerListByGroup(params);
      return data;
    },
    async selManageManufacturerListByPage(context, params) {
      const { data } = await selManageManufacturerListByPage(params);
      return data;
    },
    async selectStatIndustryInfoIntegrationListByGroup(context, params) {
      const { data } = await selectStatIndustryInfoIntegrationListByGroup(params);
      return data;
    },
    async selStatIndustryInfoIntegrationListPage(context, params) {
      const { data } = await selStatIndustryInfoIntegrationListPage(params);
      return data;
    },
  },
};
